import { apiKeys, apiMethods, apiStatuses, apiUrls } from '@/store/api/constants';
import { clearData, fetchData } from '@/store/slices/fetch-slice';
import { getData, getStatus } from '@/store/slices/helpers/helpers';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

function useGetZoneOptions({ divisionId = null } = {}) {
  const dispatch = useDispatch();
  const state = useSelector((store) => store);

  const getZoneData = getData(state, apiKeys.zoneMaster, []);
  const getZoneStatus = getStatus(state, apiKeys.zoneMaster, '');
  const getZoneLoading = apiStatuses.pending === getZoneStatus;

  useEffect(() => {
    dispatch(
      fetchData({
        url: apiUrls.zoneMaster,
        method: apiMethods.GET,
        key: apiKeys.zoneMaster
      })
    );
  }, [dispatch]);

    useEffect(() => {
    if (divisionId) {
      dispatch(
        fetchData({
          url: `${apiUrls.zoneMaster}?divisionId=${divisionId}`,
          method: apiMethods.GET,
          key: apiKeys.zoneMaster
        })
      );
    }
  }, [dispatch, divisionId]);

  const getZoneOptions = useMemo(() => {
    return getZoneData.filter((option) => option.activeStatus === "1")
    .map(({ zoneId, zoneName }) => ({
      id: zoneId,
      label: zoneName
    }))
  }, [getZoneData]);

   const getFoodsZoneOptions = useMemo(() => {
    return getZoneData
      .filter((option) => option.activeStatus === "1" && option.divisionId === divisionId)
      .map(({ zoneId, zoneName }) => ({
        id: zoneId,
        label: zoneName
      }));
  }, [getZoneData, divisionId]);

  useEffect(
    () => () => {
      dispatch(clearData({ key: [apiKeys.zoneMaster,] }));
    },
    [dispatch]
  );

  return useMemo(
    () => ({
      getZoneData,
      getZoneOptions,
      getZoneStatus,
      getZoneLoading,
      getFoodsZoneOptions
    }),
    [getZoneData, getZoneOptions, getZoneStatus, getZoneLoading,getFoodsZoneOptions]
  );
}

export default useGetZoneOptions;

